import React from "react";
import { cancelEntry } from "features/Entries/entrySlice";
import { useDispatch } from "react-redux";
import { ListPartner } from "components";
import { SERVICE } from "constants/global";
import { getTitleDecoration } from "utils/common";

const ModalCancel = ({ entry, openFn, closeFn, open = null }) => {
  const dispatch = useDispatch();

  const submit = () => {
    dispatch(
      cancelEntry({
        entry: {
          service: SERVICE,
          entry_id: entry.entry_id,
          promotion_step_id: entry.promotion_step_id,
          is_cancel: true,
        },
        openFn,
      })
    );
  };

  return (
    open && (
      <div className="modal active">
        <div className="modal-body">
          <div className="title mt-2">こちらの案件を、キャンセルしますか？</div>

          <div className="box p-2 p-md-3 my-3 text-start">
            <div>
              <div
                className="d-block d-md-inline-block mb-1 mb-md-0"
                dangerouslySetInnerHTML={{
                  __html: getTitleDecoration(
                    entry?.title_decoration?.title_decoration_content
                  ),
                }}
              ></div>

              <span className="align-middle fs-14">{entry?.title_login}</span>
            </div>
            <ListPartner entry={entry} list={entry.partnerships} />
          </div>

          <div className="group-btn-modal">
            <div onClick={closeFn} className="btn-modal">
              戻る
            </div>
            <div onClick={submit} className="btn-modal red-light">
              キャンセル
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ModalCancel;
